<template>
    <kt-panel>
        <div class="card-body">
            <kt-form-section>
                <kt-form-row>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="transaction_id">
                                {{ $t('label.transaction_hashid') }}
                            </kt-form-label>
                            <kt-form-control
                                ref="transaction_id"
                                name="transaction_id"
                                id="transaction_id"
                                v-model="query.transaction_id"
                                dir="ltr"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="switchTraceNo">
                                {{ $t('label.user_full_name') }}
                            </kt-form-label>
                            <kt-form-control
                                ref="traceCode"
                                name="traceCode"
                                id="traceCode"
                                v-model="query.user_name"
                                dir="ltr"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="amount">
                                {{ $t('label.amount') }}
                            </kt-form-label>
                            <kt-form-control
                                ref="amount"
                                dir="ltr"
                                name="amount"
                                id="amount"
                                v-model="query.amount"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="maxAmount">
                                {{ $t('label.event_type') }}
                            </kt-form-label>
                            <select class="form-control kt-selectpicker" v-model="query.event_type">                            >
                                <option
                                    v-for="(item, index) in event_types"
                                    :key="index"
                                        :value="item.value">{{item.name}}</option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="from_date">
                                {{ $t('label.from_date') }}
                            </kt-form-label>
                            <button id="reset_from_date"
                                    @click="clearFromDate"
                                    type="button"
                                    class=" btn btn-label-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                input-class="form-control"
                                id="from_date"
                                name= "from_date"
                                v-model="query.from_date"
                                type="datetime" />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="4">
                        <kt-form-group>
                            <kt-form-label for="to_date">
                                {{ $t('label.to_date') }}
                            </kt-form-label>
                            <button id="reset_to_date"
                                    @click="clearToDate"
                                    type="button"
                                    class=" btn btn-label-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                input-class="form-control"
                                id="to_date"
                                name= "to_date"
                                v-model="query.to_date"
                                type="datetime"
                            />
                        </kt-form-group>
                    </kt-col>
                </kt-form-row>
            </kt-form-section>
            <kt-form-section>
                <kt-row>
                    <kt-col xs="12" sm="6" md="6">
                        <button class="btn btn-success btn-wide" @click="action($event, query)">
                            {{ $t('transactions-report.send-request') }}
                        </button>
                    </kt-col>
                </kt-row>
            </kt-form-section>
        </div>
    </kt-panel>
</template>

<script>
import {eventType, eventTypeStr} from "@/constants/FraudEventType"
export default {
    props: {
        action: {
            default: function (e, query) {
            },
            required: true,
        },
    },
    mounted() {
    },
    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    },
    data() {
        return {
            query: {},
            event_types:[
                {
                    name: null,
                    value: null
                },

                {
                    name: eventTypeStr.MISS_MATCH_AMOUNT,
                    value: eventType.MISS_MATCH_AMOUNT
                },
                {
                    name: eventTypeStr.MISS_MATCH_CARD_NUMBER,
                    value: eventType.MISS_MATCH_CARD_NUMBER
                },
                {
                    name: eventTypeStr.MISS_MATCH_TOKEN,
                    value: eventType.MISS_MATCH_TOKEN
                },
            ]
        }
    }
}
</script>

<style>

</style>